import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
// import Card from '@material-ui/core/Card';
import moment from 'moment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import AttachMoney from '@material-ui/icons/AttachMoney';
import { ZeroState, Card, TabContainer } from '../../../components/chrome';
import eightBall from '../../../assets/images/ball/eight-ball.png';
import nineBall from '../../../assets/images/ball/nine-ball.png';
import tenBall from '../../../assets/images/ball/ten-ball.png';
import oneBall from '../../../assets/images/ball/one-ball.png';
import * as routes from '../../../config/routes';
import TournamentCardTabs from '../TournamentCardTabs';
import CheckIcon from '@material-ui/icons/Check';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import { isoCountries, getGameType, displayEnumType } from '../../../utils';

const styles = theme => ({
	listItem: {
		// padding: 0
	},
	cardNarrow: {
		margin: '24px 0px',
		padding: '5px 10px'
	}
});

class DivisionsCard extends Component {
	render() {
		const { classes, divisions } = this.props;

		return (
			<Card nopadding style={{ height: 'auto' }}>
				<h3
					style={{
						marginLeft: 24,
						marginRight: 10,
						marginTop: 10,
						marginBottom: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between'
					}}
				>
					<div>Divisions</div>
					<div>
						<IconButton>
							<AddCircleOutline />
						</IconButton>
					</div>
				</h3>
				<List defaultValue={0} style={{ flex: 1, padding: 0 }}>
					{divisions &&
						divisions.length === 0 && (
							<ZeroState
								title="You are not part of any divisions"
								style={{ marginTop: 15, marginLeft: 15, marginRight: 15, textAlign: 'center' }}
							/>
						)}
					{divisions &&
						divisions.length > 0 &&
						divisions.map((division, index) => {
							return (
								<React.Fragment key={index}>
									<Link to={`/divisions/${division.slug}`}>
										<ListItem className={classes.listItem} button>
											<Avatar src={getGameType(division.type)} className={classes.avatar} />
											<ListItemText
												primary={division.name}
												secondary={displayEnumType(division.type)}
											/>
										</ListItem>
									</Link>
								</React.Fragment>
							);
						})}
				</List>
				<Link to={`${routes.DIVISIONS}`}>
					<Button primary="true" style={{ margin: 10 }}>
						View all divisions
					</Button>
				</Link>
			</Card>
		);
	}
}

DivisionsCard.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DivisionsCard);
